import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/tabs/tabs.routes').then(m => m.TAB_ROUTES)
  },
  {
    path: 'stempel',
    loadComponent: () => import('./pages/stempel/stempel.page').then( m => m.StempelPage),
  },
  {
    path: 'auswahl',
    loadComponent: () => import('./pages/auswahl/auswahl.page').then( m => m.AuswahlPage),
  },
  {
    path: "settings",
    loadChildren: () => import('./pages/settings/settings.routes').then(m => m.SETTINGS_ROUTES)
  },
  {
    path: 'setup',
    loadComponent: () => import('./pages/setup/setup.page').then( m => m.SetupPage),
  },
  {
    path: "dashboard",
    loadComponent: () => import('./pages/terminal-status/terminal-status.page').then(m => m.TerminalStatusPage),
  },
  {
    path: 'changelog',
    loadComponent: () => import('./pages/changelog/changelog.page').then( m => m.ChangelogPage),
  },
  {
    path: 'qrscanner',
    loadComponent: () => import('./pages/qrscanner/qrscanner.page').then( m => m.QrscannerPage),
  },
  {
    path: 'error-report-confirm',
    loadComponent: () => import('./pages/error-report-confirm/error-report-confirm.page').then( m => m.ErrorReportConfirmPage)
  },
  {
    path: 'oauth', 
    loadChildren: () => import('./pages/oauth/oauth.routes').then(m => m.OAUTH_ROUTES)
  },
];
